/**
 * Core Reducers for AccountSlice
 * 
 * Handles basic account state management operations.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { AccountSliceState } from '../state';
import { AccountView } from '../../types/accountTypes';

/**
 * Set the current account
 */
export const setAccount: CaseReducer<
  AccountSliceState,
  PayloadAction<AccountView | null>
> = (state, action) => {
  state.currentAccount = action.payload;
  state.accountBackup = action.payload;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
  state.isLoading = false;
};

/**
 * Clear the current account
 */
export const clearAccount: CaseReducer<AccountSliceState> = (state) => {
  state.currentAccount = null;
  state.accountBackup = null;
  state.isEdited = false;
  state.editedFields = [];
  state.validationErrors = {};
  state.isLoading = false;
};

/**
 * Update fields on the current account
 */
export const updateAccount: CaseReducer<
  AccountSliceState,
  PayloadAction<Partial<AccountView>>
> = (state, action) => {
  if (state.currentAccount) {
    state.currentAccount = {
      ...state.currentAccount,
      ...action.payload,
    };
    state.isEdited = true;
  }
};

/**
 * Restore account from backup (discard changes)
 */
export const restoreFromBackup: CaseReducer<AccountSliceState> = (state) => {
  if (state.accountBackup) {
    state.currentAccount = state.accountBackup;
    state.isEdited = false;
    state.editedFields = [];
    state.validationErrors = {};
  }
};

/**
 * Set loading state
 */
export const setLoading: CaseReducer<
  AccountSliceState,
  PayloadAction<boolean>
> = (state, action) => {
  state.isLoading = action.payload;
};
